module.exports = __webpack_public_path__ + "img/galeria-aquicultura-1.0a7769f5.jpg";